"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _styles = require("@material-ui/core/styles");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _JssProvider = _interopRequireDefault(require("react-jss/lib/JssProvider"));

var _prism = require("../styles/prism");

var _getPageContext = require("../getPageContext");

/* eslint-disable no-underscore-dangle */
function uiThemeSideEffect(uiTheme) {
  (0, _prism.setPrismTheme)(uiTheme.paletteType);
}

var _ref = _react.default.createElement(_CssBaseline.default, null);

var AppWrapper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AppWrapper, _React$Component);

  function AppWrapper() {
    var _this;

    (0, _classCallCheck2.default)(this, AppWrapper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AppWrapper).call(this));
    _this.state = {};
    return _this;
  }

  (0, _createClass2.default)(AppWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      uiThemeSideEffect(this.props.uiTheme);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      uiThemeSideEffect(this.props.uiTheme);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var muiPageContext = this.state.muiPageContext;
      return _react.default.createElement(_JssProvider.default, {
        jss: muiPageContext.jss,
        registry: muiPageContext.sheetsRegistry,
        generateClassName: muiPageContext.generateClassName
      }, _react.default.createElement(_styles.MuiThemeProvider, {
        theme: muiPageContext.theme,
        sheetsManager: muiPageContext.sheetsManager
      }, _ref, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.muiPageContext === 'undefined') {
        return {
          prevProps: nextProps,
          muiPageContext: nextProps.muiPageContext
        };
      }

      var prevProps = prevState.prevProps;

      if (nextProps.uiTheme.paletteType !== prevProps.uiTheme.paletteType) {
        return {
          prevProps: nextProps,
          muiPageContext: (0, _getPageContext.updatePageContext)(nextProps.uiTheme)
        };
      }

      return null;
    }
  }]);
  return AppWrapper;
}(_react.default.Component);

AppWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  muiPageContext: _propTypes.default.object,
  uiTheme: _propTypes.default.object.isRequired
} : {};

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    uiTheme: state.theme
  };
})(AppWrapper);

exports.default = _default;